import type { FeatureModule } from '../types';
import overviewFeature from './overview';
import apiTesterFeature from './api-tester';
import healthFeature from './health';
import connectivityFeature from './connectivity';
import sampleDataFeature from './sample-data';

export const coreFeatures: FeatureModule[] = [
  overviewFeature,
  apiTesterFeature,
  healthFeature,
  connectivityFeature,
  sampleDataFeature
];
